import React, { useEffect } from "react";
import { withRouter, useHistory } from "react-router-dom";

function ScrollToTop({ children }) {
  const history = useHistory();

  useEffect(() => {
    const unListen = history.listen((location, action) => {
      if (action === "PUSH" || action === "REPLACE") {
        window.scrollTo(0, 0);
      }
    });

    return () => {
      unListen();
    };
  }, [history]);

  return children
}

export default withRouter(ScrollToTop);